import { createNamespacedHelpers } from 'vuex';
import {
  HOME_CARDS,
  DATATABLE,
  TOTALE_MENSILE,
  LOAD_FILTERS,
  ROW_DETAIL,
  ROW_DETAIL_COMANDA,
  VARIANTI_ARTICOLO,
  NUOVI_CLIENTI,
  TOP_ARTICOLI_OGGI,
  GRAFICO_CONTI,
  TORTA_TAVOLI,
  TORTA_SALE,
  VENDUTO_SU_ORDINATO,
  CORRISPETTIVI,
  TOP_ARTICOLI,
  ESPORTA_CORRISPETTIVI,
  DIFF_VENDUTO_ORDINATO,
  LOAD_MORE,
  FILTER_SEARCH,
} from '@/store/types';

const callRefresh = (scope, type) => {
  if ('refresh' in scope && typeof scope.refresh === 'function') {
    scope.reloadingState = new Promise(async () => { //eslint-disable-line
      await scope.refresh(type);
      scope.reloadingState = null; //eslint-disable-line
    });
  } else scope.reloadingState = null; //eslint-disable-line
};

const {
  mapActions,
  mapGetters,
  mapState,
} = createNamespacedHelpers('Stats');
const { mapGetters: mapSessionGetters } = createNamespacedHelpers('Session');
export default {
  data() {
    return {
      reloadingState: null,
    };
  },
  mounted() {
    if (!this.reloadingState && this.loggedIn) {
      callRefresh(this, 'INIT');
    }
  },
  methods: {
    ...mapActions({
      homeCardsReload: HOME_CARDS,
      nuoviClientiReload: NUOVI_CLIENTI,
      topArticoliOggiReload: TOP_ARTICOLI_OGGI,
      datatableReload: DATATABLE,
      totaleMensileReload: TOTALE_MENSILE,
      loadFilters: LOAD_FILTERS,
      loadMore: LOAD_MORE,
      filterSearch: FILTER_SEARCH,
      loadRowDetail: ROW_DETAIL,
      loadRowDetailComanda: ROW_DETAIL_COMANDA,
      loadVariantiArticolo: VARIANTI_ARTICOLO,
      graficoContiReload: GRAFICO_CONTI,
      tortaTavoliReload: TORTA_TAVOLI,
      tortaSaleReload: TORTA_SALE,
      vendutoSuOrdinatoReload: VENDUTO_SU_ORDINATO,
      corrispettiviReload: CORRISPETTIVI,
      topArticoliReload: TOP_ARTICOLI,
      esportaCorrispettivi: ESPORTA_CORRISPETTIVI,
      diffVendutoOrdinatoReload: DIFF_VENDUTO_ORDINATO,
    }),
    triggerRefresh() {
      callRefresh(this, 'MANUAL');
    },
  },
  computed: {
    ...mapGetters([
      'datatable',
      'totaleMensile',
      'filtri',
      'corrispettivi',
    ]),
    ...mapState([
      'homeCards',
      'nuoviClienti',
      'topArticoliOggi',
      'graficoConti',
      'topArticoli',
      'tortaTavoli',
      'tortaSale',
      'vendutoSuOrdinato',
      'diffVendutoOrdinato',
    ]),
    ...mapSessionGetters([
      'descrLocale',
      'coloreLocale',
      'settingsLoaded',
      'loggedIn',
      'calendar',
    ]),
    reloading() {
      return this.reloadingState !== null;
    },
  },
  watch: {
    calendar: {
      handler() {
        // console.log('CALENDAR CHANGED!', this.$options.name);
        callRefresh(this, 'CALENDAR');
      },
      deep: true,
    },
    settingsLoaded(newVal, oldVal) {
      // console.log('SETTINGS LOADED!', this.$options.name);
      if (!oldVal && newVal) callRefresh(this, 'SESSION');
    },
    localiAttivi(newVal, oldVal) {
      if (oldVal.length > 0) callRefresh(this, 'LOCALI');
    },
  },
};
